export default "__VITE_ASSET__C5Sy7NLI__"